import { z } from 'zod';
export const painSchema = z.object({
    id: z.string().optional(),
    location: z.string().min(1, 'Location is required'),
    level: z.string().min(1, 'Pain level is required'),
    treatment: z.string().optional(),
    outcome: z.string().optional(),
});
